export default "__VITE_ASSET__swAdEPnK__"